import { Flex } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import ActionsKebabMenu from "ui/components/ActionsKebabMenu";
import { MdDelete } from "react-icons/md";
import { MdEdit } from "react-icons/md";
import { OrcamentoItem } from "core/features/orcamento/typings/index";
import { getUnidadeMedida } from "./../PDFItensOrcamento/components/util";
import { UnidadeMedidaEnum } from "core/features/orcamento/typings";

export default function ItemTable({
  item,
  indexItem,
  onEdit,
  onDelete,
}: {
  item?: OrcamentoItem;
  indexItem: number | undefined;
  onDelete: any;
  onEdit: React.Dispatch<React.SetStateAction<number | undefined>>;
}) {
  return (
    <Flex
      px={4}
      h="60px"
      align="center"
      borderTop={`1px solid ${colors.gray10}`}
    >
      <Flex flex={1}>
        {item?.quantidade}
        {` `}
        {getUnidadeMedida(item?.unidadeMedidaId!)}
        {item?.quantidade! > 1
          ? `${item?.unidadeMedidaId === UnidadeMedidaEnum.Mes ? "es" : "s"}`
          : ""}
      </Flex>
      <Flex flex={4}>{item?.nome}</Flex>
      <Flex h="fit-content" py={4}>
        <ActionsKebabMenu
          indexItem={indexItem}
          item={item}
          actions={[
            {
              title: "Editar",
              icon: () => <MdEdit />,
              onClick: (_, index) => {
                if (Number.isInteger(index)) {
                  onEdit?.(index!);
                }
              },
            },
            {
              title: "Excluir",
              icon: () => <MdDelete />,
              onClick: (_, index) => {
                if (Number.isInteger(index)) {
                  onDelete?.(index!);
                }
              },
            },
          ]}
        />
      </Flex>
    </Flex>
  );
}
